import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

document.querySelectorAll('a[href^="#"]').forEach(link => {
    const href = link.getAttribute('href');

    if (href === '#') return;

    const hash = href.slice(1);
    const popupEl = document.querySelector(`#${CSS.escape(hash)}[data-popup]`);

    if (!popupEl) return;

    link.addEventListener('click', (e) => {
        e.preventDefault();

        Fancybox.show([{
            src: `#${hash}`,
            type: "inline"
        }], {
            Toolbar: false,
            closeButton: false,
        });
    });
});

document.querySelectorAll('.popup__close').forEach(item => {
    item.addEventListener('click', function () {
        const popupEl = item.closest('[data-popup]');
        if (!popupEl) return;

        Fancybox.getInstance()?.close();
    });
});